import { MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { MessageService, ConfirmationService, LazyLoadEvent } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import {MsgTemplateService} from '@app/_components/msg-template/msg-template.service';
import { ProformaService } from "@app/_components/proforma";
import { first } from "rxjs";
import { MsgCampaignService } from "@app/_components/msg-campaign/msg-campaign.service";
import { MsgCampaign } from "@app/_components/msg-campaign/msg-campaign";
import { MktgLetterComponent } from "@app/_components/mktg-letter/mktg-letter/mktg-letter.component";
import { MktgLetterService } from "@app/_components/mktg-letter/mktg-letter.service";

@Component({
    selector: "app-msg-campaign",
    templateUrl: "./proforma-generates.component.html",
    styleUrls: ["./proforma-generates.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ProformaGeneratesComponent implements OnInit {
  ownerLeadProfile = false;
  propertyLeadProfile = false;
  constructor(
    private primengConfig: PrimeNGConfig,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private msgTemplateService: MsgTemplateService,
    private mktgLetterService: MktgLetterService,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private proformaService: ProformaService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title;
  }

  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  currentDate: any;
  currentSearchForm: any;
  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  //Proforma
  proformaList: any[]=[];
  copyingProforma: any;
  proformaNotSelected: boolean = false;
  letterNotSelected: boolean = false;
  proformas: any[] = [];
  mktgLetters: any[] = [];
  marketingLetter: any;
  updateProformaList:boolean = false;

  validationMessages = {
    proformaId: [{ type: 'required', message: 'Please select Proforma to be copied.' }],
    mktgLetterId: [{ type: 'required', message: 'Please select Marketing Letter' }],
    senderName: [{ type: 'required', message: 'Please enter sender name' }],
    senderEmail: [{ type: 'required', message: 'Please enter sender email' }],
    senderMobile: [{ type: 'required', message: 'Please enter sender email' }],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.currentDate = new Date();
    this.formBuild();
    let event : LazyLoadEvent = {};
    this.loadProformaList(event);
    this.fetchMktgLetters();
  }

  onSearchSubmit(searchForm: any)
  {
    this.currentSearchForm = searchForm;
    this.generateProformaCount(searchForm,[] );
  }

  generateProformaCount(searchForm, selectedPropertyCodes: any)
  {
    try
    {
      if(this.copyingProforma == undefined || this.copyingProforma.proformaId == undefined) {
        this.proformaNotSelected = true;
        return;
      } else {
        this.proformaNotSelected = false;
      }

      //Marketing letter validation
      if(this.form1.value.mktgLetterId == undefined || this.form1.value.mktgLetterId == '') {
        this.letterNotSelected = true;
        return;
      } else {
        this.letterNotSelected = false;
      }

      if(this.copyingProforma != undefined && this.copyingProforma.proformaId != undefined) {
        searchForm.proformaId = this.copyingProforma.proformaId;
      }
      this.formLoading = true;
      this.proformaService.generateProformaCount(searchForm)
        .subscribe(
          res =>
          {
            this.formLoading = false;
            this.confirmationService.confirm({
              message:
                "There are total <b>" + res.data.proformaCount + " </b> of Prformas will be generated. Are you sure?",
              header: "Proforma Generation Confirm",
              icon: "pi pi-exclamation-triangle",
              accept: () => {
                this.generateProformas(searchForm, selectedPropertyCodes);
              },
            });
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }
  
  generateProformas(searchForm, selectedPropertyCodes: any)
  {
    try
    {
      if(this.copyingProforma == undefined || this.copyingProforma.proformaId == undefined) {
        this.proformaNotSelected = true;
        return;
      } else {
        this.proformaNotSelected = false;
      }

      this.formLoading = true;
      // searchForm.msgCampaignId = this.msgCampaignId;
      if(this.copyingProforma != undefined && this.copyingProforma.proformaId != undefined) {
        searchForm.proformaId = this.copyingProforma.proformaId;
      }
      this.proformaService.generateProformas(searchForm)
        .subscribe(
          res =>
          {
            this.formLoading = false;
            this.proformas = res.data.proformas;
            this.updateProformaList = !this.updateProformaList;
            // this.msgVOListUpdated = !this.msgVOListUpdated;
            // console.log('getAdvertisedRates SUCCESS: ' + JSON.stringify(res.data.advertisedRates));
            this.messageService.add({ sticky: true, key: 'r', severity: 'success', summary: 'Success', detail: 'Updated the following properties with the new settings: <br><br>' + selectedPropertyCodes });
          },
          err =>
          {
            console.log('getAdvertisedRates FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
            this.formLoading = false;
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }

  //On marketing letter selection
  changeMktgLetter(mktgLetter: any){
    //Remove message on letter selection
    if(mktgLetter.value) {
      this.letterNotSelected = false;
    }

    //Assign selected letter to marketingLetter object
		if (this.mktgLetters.length > 0) {
			this.mktgLetters.forEach(marketingLetter => {
				if (marketingLetter.mktgLetterId == mktgLetter.value) {
					this.marketingLetter = marketingLetter;
				}
			});
		}
	}

  /*********
		* Edit Marketing Letter
		*
		*/
	formEditMktgLetter() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		
		dialogConfig.data = {
			mktgLetter: this.marketingLetter,
			title: 'Marketing Letter'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MktgLetterComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log("Dialog output:", data);
				this.mktgLetters = [];
				this.fetchMktgLetters();
				this.form1.patchValue({
					mktgLetterId: data.mktgLetterId
				});

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

  //PropertyLead Profile

	fetchMktgLetters() {
		try {
			this.mktgLetterService.findAll().subscribe(
				(res) => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.mktgLetters = res.data.mktgLetters;
				},
				(err) => {
					console.log("Feature-Update FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { }
			);
		} catch (error) {
			console.log("Form Invalid: " + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

  sendProforma() {
    console.log("proforma generate send: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }

      let proformaIds = [];
      
      //Fetch proforma Ids of all the generated proforma
      this.proformas.forEach(proforma => {
        proformaIds.push(proforma.proformaId)
      });

      let proforma = {
        mktgLetterId : this.form1.value.mktgLetterId,
        proformaIds : proformaIds,
        senderName : this.form1.value.senderName,
        senderEmail : this.form1.value.senderEmail,
        senderMobile : this.form1.value.senderMobile
      };

      this.formLoading = true;
      this.proformaService.sendBulkProforma(proforma).subscribe(
        (res: any) => {
          console.log("proforma send SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          this.formLoading = true;
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      ownerLeadProfile: [],
      propertyLeadProfile: [],
      proformaId: ['', Validators.required],
      mktgLetterId: ['', Validators.required],
      senderName: ['', Validators.required],
      senderEmail: ['', Validators.required],
      senderMobile: [],
    });
  }
  
  updateTableStatus(tableName: any, status: any) {
      if(tableName === 'owner-lead-profile'){
        this.ownerLeadProfile = status.checked;
      }
      if(tableName === 'property-lead-profile'){
        this.propertyLeadProfile = status.checked;
      }
    }

    //Fetch proforma to show in proforma list to be copied
    loadProformaList(event: LazyLoadEvent) {
      this.formLoading = true;
      event.first = 0;
      event.rows = 1000;
      event.sortOrder = 1;
      event.multiSortMeta = [{field:"createDate",order: -1}];
      event.globalFilter = null;
      // Fetch proforma status is Draft, Published, Internal Only or Template and Visibility is Public
      event.filters = {"status":{"value":[0,1,2,3],"matchMode":"in"}, "visibility":{"value":[0],"matchMode":"in"}}
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'createDate', order: -1 });
      }
      const pageNumber = Math.round(event.first / event.rows);
      this.proformaService.findByFilter(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe(
          (res: any) => {
            if(res.data.proformas != undefined) {
              res.data.proformas.forEach(proforma => {
                var nameOption = proforma.name + ' - ';
                var subjAdrStreet = proforma.propertyLeadProfile?.subjAdrStreet != undefined ? (proforma.propertyLeadProfile?.subjAdrStreet) : '';
                var subjAdrUnit = proforma.propertyLeadProfile?.subjAdrUnit != undefined ? ('#'+proforma.propertyLeadProfile?.subjAdrUnit) : '';
                var subjAdrCity = proforma.propertyLeadProfile?.subjAdrCity != undefined ? (proforma.propertyLeadProfile?.subjAdrCity + ',') : '';
                var subjAdrState = proforma.propertyLeadProfile?.subjAdrState != undefined ? (proforma.propertyLeadProfile?.subjAdrState) : '';
                var stableYrGrossTtl = proforma.stableYrGrossTtl != undefined ? ('$' + proforma.stableYrGrossTtl) : '';
                var realtorFirstName = proforma.realtorProfile?.firstName != undefined ? (proforma.realtorProfile?.firstName + ' ') : '';
                var realtorLastName = proforma.realtorProfile?.lastName != undefined ? (proforma.realtorProfile?.lastName) : '';
                var realtorName = realtorFirstName + realtorLastName;
                var ownerFirstName = proforma.ownerLeadProfile?.firstName != undefined ? (proforma.ownerLeadProfile?.firstName + ' ') : '';
                var ownerLastName = proforma.ownerLeadProfile?.lastName != undefined ? (proforma.ownerLeadProfile?.lastName) : '';
                var ownerName = ownerFirstName + ownerLastName;
                var preparedDate = proforma.preparedDate != undefined ? (proforma.preparedDate) : '';
                var visibility = proforma.visibility != undefined ? (this.proformaService.getVisibilityName(proforma)) : '';
                //Show proforma option in dropdown with custom string
                proforma.customOption = nameOption + ' ' + subjAdrStreet + ' ' + subjAdrUnit + ' ' + 
                          subjAdrCity + ' ' + subjAdrState + ' ' + stableYrGrossTtl + ' ' + ownerName + ' ' + 
                          realtorName + ' ' + preparedDate + ' ' + visibility
              });
            }
            this.proformaList = res.data.proformas;
            this.proformas = res.data.proformas;
            this.formLoading = false;
          },
          (err: any) => {
            console.error('reviews list error!: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; }
        );
    }

    onSelectProforma(event: any){
      if (this.proformaList.length > 0) {
        this.proformaList.forEach(proforma => {
          if (proforma.proformaId == event.value) {
            this.copyingProforma = proforma;
            this.proformaNotSelected = false;
          }
        });
      }
    }
}
